import { render } from "./OverlayBoxParams.vue?vue&type=template&id=57e5a000&scoped=true"
import script from "./OverlayBoxParams.vue?vue&type=script&lang=js"
export * from "./OverlayBoxParams.vue?vue&type=script&lang=js"

import "./OverlayBoxParams.vue?vue&type=style&index=0&id=57e5a000&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e5a000"]])

export default __exports__